import { sendYandexGoal } from '../../../services/yandexMetrikaService'

export const isTelegramPaymentRedirectAvailable = () => {
  return Boolean(window.Telegram?.WebApp?.openLink && window.Telegram?.WebApp?.initData)
}

const PAYMENT_WINDOW_LOADER_HTML = `<!doctype html>
<html lang="en">
<head>
  <meta charset="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <title>Loading</title>
  <style>
    html, body {
      margin: 0;
      width: 100%;
      height: 100%;
      background: #000;
    }

    body {
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;
    }

    .spinner {
      width: 48px;
      height: 48px;
      border-radius: 50%;
      border: 4px solid rgba(0, 255, 127, 0.2);
      border-top-color: #00ff7f;
      animation: spin 0.8s linear infinite;
    }

    @keyframes spin {
      to {
        transform: rotate(360deg);
      }
    }
  </style>
</head>
<body>
  <div class="spinner"></div>
</body>
</html>`

export const prepareExternalPaymentWindow = () => {
  if (isTelegramPaymentRedirectAvailable()) {
    return null
  }

  const paymentWindow = window.open('', '_blank')

  if (!paymentWindow) {
    return null
  }

  try {
    paymentWindow.opener = null
    paymentWindow.document.write(PAYMENT_WINDOW_LOADER_HTML)
    paymentWindow.document.close()
  } catch (error) {
    console.warn('⚠️ Не удалось подготовить окно оплаты:', error)
  }

  return paymentWindow
}

export const closePreparedPaymentWindow = (paymentWindow) => {
  if (!paymentWindow || paymentWindow.closed) {
    return
  }

  try {
    paymentWindow.close()
  } catch (error) {
    console.warn('⚠️ Не удалось закрыть подготовленное окно оплаты:', error)
  }
}

export const openExternalPaymentLink = (paymentLink, onRedirect, paymentMethodName = 'Payment', paymentWindow = null) => {
  if (!paymentLink) return

  const finishRedirect = () => {
    sendYandexGoal('deposit-start')

    if (onRedirect) {
      onRedirect({ success: true })
    }
  }

  const openInBrowser = () => {
    if (paymentWindow && !paymentWindow.closed) {
      paymentWindow.location.replace(paymentLink)
      console.log(`🌐 ${paymentMethodName} payment link opened in prepared browser tab:`, paymentLink)
      finishRedirect()
      return
    }

    const openedWindow = window.open(paymentLink, '_blank')

    if (openedWindow) {
      try {
        openedWindow.opener = null
      } catch (error) {
        console.warn(`⚠️ ${paymentMethodName} payment window opener cleanup failed:`, error)
      }

      console.log(`🌐 ${paymentMethodName} payment link opened in browser:`, paymentLink)
      finishRedirect()
      return
    }

    window.location.assign(paymentLink)
    console.log(`🌐 ${paymentMethodName} payment link opened in current tab:`, paymentLink)
    finishRedirect()
  }

  if (!isTelegramPaymentRedirectAvailable()) {
    openInBrowser()
    return
  }

  try {
    window.Telegram.WebApp.openLink(paymentLink)
    console.log(`📱 ${paymentMethodName} payment link opened in Telegram:`, paymentLink)
    finishRedirect()
  } catch (error) {
    console.error(`❌ Error opening ${paymentMethodName} payment link in Telegram:`, error)
    openInBrowser()
  }
}

export default openExternalPaymentLink
